import { render, staticRenderFns } from "./AddNanolinks.vue?vue&type=template&id=639b0f05&"
import script from "./AddNanolinks.vue?vue&type=script&lang=js&"
export * from "./AddNanolinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports